import React from "react";
import { Toast, Button } from "antd-mobile";

import "./index.less";
class vehicleInquiryRule extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {};
    }

    componentDidMount() {}

    viewPort = () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf("micromessenger") > -1,
            isQQ: u.indexOf("qq/") > -1,
            trident: u.indexOf("trident") > -1, //IE内核
            presto: u.indexOf("presto") > -1, //opera内核
            webKit: u.indexOf("applewebkit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("gecko") > -1 && u.indexOf("khtml") == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) || !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf("android") > -1 || u.indexOf("linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iphone") > -1 || u.indexOf("mac") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("ipad") > -1, //是否iPad
            webApp: u.indexOf("safari") == -1, //是否web应该程序，没有头部与底部
        };
    };

    render() {
        const { urlOps, qrImg, detailData } = this.state;
        // console.log(urlOps)
        return (
            <div className="vehicleInquiryRuleBox">
                <div>
                    <div style={{ lineHeight: "2" }}>
                        尊敬的远程慧联用户：
                        <br />
                        感谢您使用保险咨询业务。为确保您充分了解服务细则及授权事项，请仔细阅读本告知书：
                    </div>
                    <h2 style={{ marginTop: "0.16rem" }}>服务说明</h2>
                    <div style={{ lineHeight: "2" }}>
                        1、服务范围
                        <br />
                        目前本服务仅面向深圳地区部分受邀用户开放，非服务对象将收到"暂未开通服务"提示。
                        <br />
                        2、服务方式
                        <br />
                        平台方：浙江远程慧联为您提供保险咨询的服务入口；
                        <br />
                        服务方：本次保险咨询服务提供方为深圳恒泰运供应链管理有限公司，恒泰运将根据您提交的信息，联合保险公司评估，为您提供定制化保险方案；
                    </div>
                    <h2 style={{ marginTop: "0.16rem" }}>重要提示</h2>
                    <div style={{ lineHeight: "2" }}>
                        1、定价机制：最终保费将由恒泰运协同合作保司核价确认，平台不参与报价决策及费用优惠承诺。
                        <br />
                        2、权责声明：保险方案解释权及服务质量保障责任均由恒泰运承担，平台仅提供技术支持服务。
                        <br />
                        <br />
                        如您确认理解上述内容，欢迎继续使用本服务。
                        <br />
                        感谢您对远程慧联的信任与支持！我们期待为您提供优质服务体验。
                    </div>
                </div>
            </div>
        );
    }
}

export default vehicleInquiryRule;



// WEBPACK FOOTER //
// ./src/vehicleInquiry/rule/index.js